// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 563) return "static/chunks/563-66e6d838dceee0d2.js";
	if (chunkId === 6979) return "static/chunks/6979-5e418d3bcdc344fd.js";
	if (chunkId === 6589) return "static/chunks/6589-01c52376d9773eb7.js";
	if (chunkId === 7942) return "static/chunks/7942-abc9bbdd829d1468.js";
	if (chunkId === 9266) return "static/chunks/9266-283664cad0b34b8f.js";
	if (chunkId === 506) return "static/chunks/506-31cf99a45f7918be.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"9834d9252d8934a4","754":"65f2ec1d9a90ad11","1053":"b9e0abb281af445d","1822":"6551bbcf2c28cf01","1853":"0ca1903efce342bc","2147":"5cf504b45fcda50d","2661":"beeeb637eea6af96","4980":"5708b4f6d19a67b7","5496":"4acec7c478088a78","8406":"76755798a948a256","8968":"eba0647cb93ce652","9760":"d9bee2b791a8799a"}[chunkId] + ".js";
};